var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarineProtectionRestoration = function SvgMarineProtectionRestoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#89E8DF",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M16 25.167a.8.8 0 0 1-.317-.067c-5.541-2.308-8.016-5.75-8.016-11.158V9.325c0-.258.116-.492.316-.65s.459-.217.709-.158c2.516.591 4.941-.084 6.758-1.684a.836.836 0 0 1 1.1 0c1.817 1.6 4.242 2.275 6.758 1.684a.832.832 0 0 1 1.025.808v4.617c0 5.408-2.475 8.85-8.016 11.158a.8.8 0 0 1-.317.067M9.333 10.325v3.617c0 4.658 1.934 7.433 6.667 9.483 4.733-2.058 6.667-4.825 6.667-9.483v-3.617c-2.425.308-4.775-.367-6.667-1.792-1.892 1.425-4.242 2.1-6.667 1.792"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M16.85 19.083h-.083c-1.084-.025-2.25-.458-3.15-1.166l-1.692.691a.79.79 0 0 1-.825-.141.79.79 0 0 1-.233-.809l.716-2.491-.716-2.492a.792.792 0 0 1 1.058-.95l1.658.683a5.6 5.6 0 0 1 3.309-1.158c2.191.042 4.716 1.792 4.683 3.992-.017.85-.4 1.666-1.117 2.358-.941.908-2.35 1.483-3.616 1.483zm-3.075-2.875c.2 0 .4.075.55.225.642.625 1.633 1.05 2.475 1.067.85.025 1.9-.4 2.567-1.042.283-.275.625-.716.633-1.241.017-1.225-1.733-2.359-3.133-2.384-.892-.041-1.909.409-2.575 1.059a.8.8 0 0 1-.85.166l-.6-.241.325 1.141a.8.8 0 0 1 0 .442l-.325 1.142.633-.259a.8.8 0 0 1 .3-.058z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M18.083 16a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })));
};
export default SvgMarineProtectionRestoration;